export default __webpack_public_path__ + "static/media/STL Postal Ballot Notice.b70dd689.pdf";